import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["formats", "value"];
import I18n from 'I18n';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
// @ts-expect-error not typed
import withDisabledContext from '../hoc/withDisabledContext';
import { TextToolbarSelect, TextToolbarSelectOption } from '../editor/TextToolbarSelect';
import { jsx as _jsx } from "react/jsx-runtime";
const FormatSelect = _ref => {
  let {
      formats,
      value
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(TextToolbarSelect, Object.assign({}, rest, {
    searchable: false,
    options: formats,
    placeholder: I18n.text('RichTextLib.formatting.FormatSelect.placeholder'),
    value: value,
    optionRenderer: option => /*#__PURE__*/_jsx(Tooltip, {
      disabled: !option.tooltip,
      placement: "right",
      title: option.tooltip,
      children: /*#__PURE__*/_jsx(TextToolbarSelectOption, {
        disabled: option.disabled,
        children: option.text
      })
    })
  }));
};
export default withDisabledContext(FormatSelect);